<template>
  <div
    :class="wrapperClass"
    :style="{ minHeight: $is_mobile_view ? '70vh' : '0px' }">
    <div class="mb-5" :class="containerClass">
      <!-- TAGLINE & SUBTAGLINE  -->
      <div class="w-100 mb-4">
        <p
          class="mb-0"
          :class="!$is_mobile_view ? 'heading-4-1' : 'heading-5-2'">
          {{ getActiveHotelModule.title }}
        </p>
        <p
          class="mb-0"
          v-if="$isNotEmptyV2(getActiveHotelModule.subtitle)"
          :class="!$is_mobile_view ? 'body-1' : 'body-2'">
          {{ getActiveHotelModule.subtitle }}
        </p>

        <div
          v-if="getActiveHotelModule.module === 'OTHER'"
          class="p-2-5 rounded-4 mb-3 d-inline-flex align-items-start mt-3"
          :class="{ 'w-100': $is_mobile_view }"
          style="
            border-left: 4px solid #17a2b8;
            background-color: rgba(23, 162, 184, 0.05);
            border-right: 1px solid #17a2b8;
            border-block: 1px solid #17a2b8;
          ">
          <div class="flex-shrink-0 mr-3">
            <svg
              width="26px"
              height="18px"
              viewBox="0 0 29 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23.7273 2.66667H13.1818V12H2.63636V0H0V20H2.63636V16H26.3636V20H29V8C29 6.58551 28.4445 5.22896 27.4557 4.22876C26.4668 3.22857 25.1257 2.66667 23.7273 2.66667ZM7.90909 10.6667C8.9579 10.6667 9.96376 10.2452 10.7054 9.49509C11.447 8.74495 11.8636 7.72753 11.8636 6.66667C11.8636 5.6058 11.447 4.58839 10.7054 3.83824C9.96376 3.08809 8.9579 2.66667 7.90909 2.66667C6.86028 2.66667 5.85443 3.08809 5.11281 3.83824C4.37118 4.58839 3.95455 5.6058 3.95455 6.66667C3.95455 7.72753 4.37118 8.74495 5.11281 9.49509C5.85443 10.2452 6.86028 10.6667 7.90909 10.6667Z"
                fill="#17A2B8" />
            </svg>
          </div>
          <div class="w-100 pt-1">
            <p class="body-2-4 mb-1">Required Room</p>
            <p class="body-3-1 mb-0">
              You must book a room to order a product from this category.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div :class="isNewDesign ? 'col-12' : 'col-md-9 col-12'">
          <div
            :class="
              $is_mobile_view ? '' : 'bg-light-desktop py-3 container rounded-4'
            ">
            <div class="row" v-if="pageStatus.isLoad">
              <div class="col-12 col-md-6 mb-4" v-for="i in 2">
                <div class="w-100">
                  <div class="row no-gutters">
                    <div class="col-4">
                      <div
                        class="w-100 radius-6 position-relative"
                        style="height: 110px; overflow: hidden">
                        <b-skeleton-img
                          no-aspect
                          height="110px"></b-skeleton-img>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="pl-3">
                        <b-skeleton
                          width="50%"
                          height="21.3333px"
                          class="mb-1"></b-skeleton>
                        <b-skeleton
                          width="100%"
                          height="16px"
                          class="mb-1"></b-skeleton>
                        <b-skeleton
                          width="30%"
                          height="18px"
                          class="mb-2"></b-skeleton>
                        <b-skeleton
                          width="30%"
                          height="32px"
                          class="d-table ml-auto"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template v-else>
              <div class="py-4" v-if="pageStatus.error != ''">
                <ErrorMessage :message="pageStatus.error" />
              </div>
              <template v-else>
                <div class="row slim-grid-row mb-3">
                  <div
                    class="col-xl-6 col-12 mb-4"
                    v-for="(product, index) in productList">
                    <GeneralProduct
                      v-if="categoryType === 'GENERAL'"
                      :data="product" />

                    <OutletProduct
                      v-else-if="categoryType == 'RESTAURANT'"
                      type="block"
                      :data="product"
                      :index="index"
                      :pos="getActiveHotelModule.merchant_pos"
                      :products_length="productList.length"
                      page_module="additional_service" />

                    <ActivityProduct
                      v-else-if="categoryType === 'ACTIVITY'"
                      :data="product"
                      :general_data="generalData"
                      page_module="additional_service" />

                    <VoucherProduct
                      v-else-if="categoryType === 'VOUCHER'"
                      :data="product"
                      page_module="additional_service" />
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="col-3" v-if="!($is_mobile_view || isNewDesign)">
          <SearchPreviewCart module="ADDITIONAL" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { get } from '@/services/index.js';
import GeneralProduct from '@/components/hotel/be/additionalService/Product';
import OutletProduct from '../concierge/pos/Product';
import ActivityProduct from '../concierge/activity/Product';
import VoucherProduct from '@/components/hotel/upselling/VoucherItem';
import SearchPreviewCart from './SearchPreviewCart.vue';

export default {
  components: {
    GeneralProduct,
    OutletProduct,
    ActivityProduct,
    VoucherProduct,
    SearchPreviewCart,
  },
  data() {
    return {
      pageStatus: {
        isLoad: true,
        error: '',
      },
      productList: [],
      generalData: {},
    };
  },
  computed: {
    ...mapGetters(['getMerchant', 'getActiveHotelModule']),
    categoryType() {
      const { merchant_pos = null } = this.getActiveHotelModule;
      if (!this.$isNotEmpty(merchant_pos)) return 'GENERAL';

      switch (merchant_pos.pos_type) {
        case 'RESTAURANT':
          return 'RESTAURANT';
        case 'SPA':
        case 'ACTIVITY':
          return 'ACTIVITY';
        case 'VOUCHER':
          return 'VOUCHER';
        default:
          return '';
      }
    },
    isNewDesign() {
      return (
        this.getMerchant.booking_engine_header_type == 'MULTI_IMAGE_BANNER'
      );
    },
    wrapperClass() {
      if (this.isNewDesign) return 'w-100';
      return this.$is_mobile_view ? 'container' : 'px-3 mb-3 pt-4';
    },
    containerClass() {
      if (this.isNewDesign) return 'w-100';
      return this.$is_mobile_view ? '' : 'px-5';
    },
  },
  watch: {
    getActiveHotelModule() {
      this.loadConfigAndProduct();
    },
  },
  mounted() {
    this.loadConfigAndProduct();
  },
  methods: {
    async loadConfigAndProduct() {
      try {
        this.pageStatus = { isLoad: true, error: '' };

        const {
          id,
          merchant_pos = {},
          page_module,
        } = this.getActiveHotelModule;
        if (this.$isNotEmpty(merchant_pos) && page_module === 'ACTIVITY') {
          const isSpaModule = merchant_pos.pos_type === 'SPA';
          await this.getGeneralConfig(isSpaModule, merchant_pos.id);
        }

        await this.getProductList(id);
      } catch (error) {
        this.pageStatus.error = error.message || 'An unexpected error occurred';
      } finally {
        this.pageStatus.isLoad = false;
      }
    },
    async getGeneralConfig(isSpaModule = true, merchantPosId) {
      try {
        this.generalData = {};

        const apiConfig = {
          module: isSpaModule ? 'CONCIERGE' : 'CORE_HOTEL',
          url: isSpaModule
            ? 'spa/general'
            : `merchant-pos/${merchantPosId}/general`,
          params: { merchant_id: this.getMerchant.id },
        };
        const apiResponse = await get(
          apiConfig.module,
          apiConfig.url,
          apiConfig.params
        );

        const { success, data = null, message = '' } = apiResponse.data;
        if (!success) throw new Error(message);
        this.generalData = data;
      } catch (error) {
        throw error;
      }
    },
    async getProductList(categoryId) {
      try {
        const apiParams = {
          merchant_id: this.getMerchant.id,
          category_id: categoryId,
        };
        const apiResponse = await get(
          'CORE_HOTEL',
          'hotel-additional-service',
          apiParams
        );

        const { success, data = null, message = '' } = apiResponse.data;
        if (!success) throw new Error(message);
        this.productList = data;
      } catch (error) {
        throw error;
      }
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 992px) {
  .px-5 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media screen and (max-width: 1200px) {
  .px-5 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/AdditionalModule.vue